import Keycloak from 'keycloak-js';


// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  //url: "https://keycloak.dev1.smarpay.eu/",
  //realm: "smarpay",
  //clientId: "react-client-dev",
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,

  initOptions: {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri:
      window.location.origin + '/assets/silent-check-sso.html'
  },
  checkLoginIframe: false,

});


const keycloakInitOptions = {

  checkLoginIframe: false,

  onLoad: 'login-required',

  //onLoad: 'check-sso',  
  //silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
}



export { keycloak, keycloakInitOptions }
